import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import _size from "lodash/size"
import _find from "lodash/find"
import _get from "lodash/get"

import ThemeConsumer from "shared/components/ThemeConsumer"
import TypographLink from "shared/components/TypographLink"
import LogoutButton from "components/LogoutButton"
import SubItem from "./SubItem"

import { isMatchingPath } from "services/utils/isMatchingPath"

const MenuItem = ({
  iconComponent: Icon = () => null,
  name,
  route,
  theme,
  isLogout = false,
  showSubItems = false,
  subItems = [],
  arrowIcon: ArrowIcon = () => null,
  currentPath,
  id,
  nameBadge,
  isMonitoring,
  hasNewMenu,
  newMenuLabel,
  beegolAccess,
  customer,
  saveOperation,
  operation
}) => {
  const active =
    isMatchingPath(currentPath, route.href) ||
    !!_find(subItems, (item) => item.route.href === currentPath)

  const linkClasses = classnames(
    {
      [theme.containerItem]: !active,
      [theme.containerItemActive]: active
    },
    theme.p3,
    "u-flex u-flexAlignItemsCenter"
  )

  if (isLogout) {
    const buttonClasses = classnames(
      "u-flexJustifyStart",
      linkClasses,
      theme.w100
    )

    return (
      <li className={theme.mb3}>
        <LogoutButton
          classNames={buttonClasses}
          preset="item"
          icon={Icon}
          atPosition="start"
          innerClasses={theme.ml3}
          id={id}
        />
      </li>
    )
  }

  const iconClasses = classnames(theme.mr2)

  if (_size(subItems) && showSubItems) {
    const props = {
      id,
      iconComponent: Icon,
      name,
      active,
      arrowIcon: ArrowIcon,
      subItems,
      linkClasses,
      iconClasses,
      currentPath,
      nameBadge,
      isMonitoring,
      hasNewMenu,
      newMenuLabel,
      beegolAccess,
      customer,
      saveOperation,
      operation
    }

    return <SubItem {...props} />
  }

  const target = "_self"
  const shouldTrack = _get(operation, "shouldTrack", false)

  const handleMenuClick = () => {
    if (
      shouldTrack &&
      customer &&
      saveOperation &&
      operation &&
      !route.isExternal
    ) {
      saveOperation(
        customer,
        _get(operation, "numTelefone", ""),
        _get(operation, "type", ""),
        _get(operation, "action", "CLICK"),
        _get(operation, "integrity", "PENDING"),
        _get(operation, "protocol", ""),
        _get(operation, "obs", "")
      )
    }
  }

  return (
    <li className={theme.mb3}>
      <TypographLink
        classNames={linkClasses}
        isActive={active}
        to={route.href}
        preset="item"
        size="small"
        isExternal={route.isExternal}
        target={target}
        id={id}
        onClick={shouldTrack ? handleMenuClick : undefined}
      >
        <Icon className={iconClasses} />
        {name}
      </TypographLink>
    </li>
  )
}

MenuItem.propTypes = {
  name: PropTypes.string,
  nameBadge: PropTypes.string,
  route: PropTypes.shape({
    href: PropTypes.string,
    isExternal: PropTypes.bool
  }),
  currentPath: PropTypes.string,
  theme: PropTypes.shape({
    p3: PropTypes.string,
    mb3: PropTypes.string,
    mr2: PropTypes.string,
    ml3: PropTypes.string,
    w100: PropTypes.string,
    containerItem: PropTypes.string,
    containerItemActive: PropTypes.string,
    linkContainer: PropTypes.string,
    iconColor: PropTypes.string,
    iconColorActive: PropTypes.string,
    iconArrowColor: PropTypes.string,
    iconArrowColorActive: PropTypes.string
  }),
  renderIcon: PropTypes.func,
  iconComponent: PropTypes.func,
  isLogout: PropTypes.bool,
  showSubItems: PropTypes.bool,
  subItems: PropTypes.array,
  arrowIcon: PropTypes.func,
  id: PropTypes.string,
  isMonitoring: PropTypes.bool,
  hasNewMenu: PropTypes.bool,
  newMenuLabel: PropTypes.string,
  beegolAccess: PropTypes.bool,
  customer: PropTypes.object,
  saveOperation: PropTypes.func,
  operation: PropTypes.object
}

export default ThemeConsumer("UIMenu")(MenuItem)



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Menu/MenuItem.js